<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../common/Image/FontAwesomeView.svelte";
    import {BinaryTable} from "../../lib/Table/BinaryTable";


    export let binary;

    $:isShow = (() => {
        if (binary == null) {
            return false;
        }

        return true;
    })();

    $: downloadUrl = (() => {
        return createDownloadUrl(binary, false);
    })();

    $: canDownload = (() => {
        if (binary == null) {
            return false;
        }
        if (binary.download_key == null) {
            return false;
        }
        const status = binary.status;
        if (status !== BinaryTable.Status.Success) {
            return false;
        }
        return true;
    })();

    $: convertDownloadUrl = (() => {
        return createDownloadUrl(binary, true);
    })();

    $: canConvertDownload = (() => {
        if (binary == null) {
            return false;
        }
        if (binary.download_key == null) {
            return false;
        }
        if (!isExistConveted) {
            return false;
        }
        const convertStatus = binary.convert_status;
        if (convertStatus !== BinaryTable.ConvertStatus.Success) {
            return false;
        }
        return true;
    })();


    $: isExistConveted = (() => {
        if (binary.converted_s3_key != null) {
            return true;
        } else {
            return false;
        }
    })();

    $: disableMessage = (() => {
        if (binary == null) {
            return 'バイナリ情報がありません';
        }
        const status = binary.status;
        if (!canDownload && !canConvertDownload) {
            return `現在、ダウンロードできません。\n処理中 or キャンセル or エラーの可能性があります。`;
        }

        return null;
    })();


    onMount(() => {
    });

    function createDownloadUrl(binary, isConverted) {
        const downloadKey = binary.download_key;
        let url = `/api/binary/download?download_key=${downloadKey}`;
        if (isConverted) {
            url += `&converted`;
        }

        return url;
    }


</script>

{#if isShow}
    <span class="binary-download-view">
        {#if canDownload}
            <div>
                <a href={downloadUrl} target="_blank" rel="noreferrer noopenner">
                    <button class="download-button">
                        <FontAwesomeView icon="download"/>
                        { binary.file_extension }
                    </button>

                </a>

            </div>
        {/if}

        {#if canConvertDownload}
            <div>
                <a href={convertDownloadUrl} target="_blank" rel="noreferrer noopenner">
                    <button class="download-button">
                        <FontAwesomeView icon="download"/>
                        { binary.converted_file_extension }
                    </button>

                </a>

            </div>
        {/if}

        {#if disableMessage != null}
            <div class="disable-message">
                { disableMessage }
            </div>
        {/if}



    </span>
{/if}

<style lang="scss">
    .binary-download-view {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;

        .download-button {
            padding-left: 1em;
            padding-right: 1em;
        }

        .disable-message {
            font-size: 0.9em;
            opacity: 0.5;
            white-space: pre-wrap;
        }

    }
</style>